import React from 'react'
import { withRouter } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import storage from "../../../Storage";
import { SITE, getElement, sendNotfication } from "../../../Helper";
import Terms from "./Terms";
import List from "./List";
import Modal from "react-bootstrap/Modal";

class Affiliate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            token: storage.getKey('token') ? storage.getKey('token') : null,
            logged: false,
            show: false,
            code: storage.getKey('referral_code') ? storage.getKey('referral_code') : null,
            ref_code: ''
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentWillMount() {
        if (this.state.token !== null) {
            this.setState({ logged: true });
        }

        if (this.props.match) {
            this.ref_code = this.props.match.params.code;
        }

        storage.setKey('ref_code', this.ref_code);

        if (this.ref_code) {
            // Redirect to the index page
            // return <Redirect to="/" />;
            this.props.history.push('/');
        }
    };

    componentDidMount() {
        this.checkRoute();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.checkRoute();
        }
    }

    checkRoute() {
        if (this.props.location.pathname === '/vip-rewards') {
            if (!this.state.show) {
                this.handleShow();
            }
        }
    }

    copyAddress(id) {
        var address = getElement('#' + id);
        address.select();
        address.setSelectionRange(0, 99999); /*For mobile devices*/
        document.execCommand("copy");
        const { t } = this.props;

        return sendNotfication('Refferal Code Copied', 'success', 'bottom-left');
    }

    handleClose() {
        this.setState({ show: false, effect: 'zoomOut' });
        if (this.props.location.pathname === '/vip-rewards') {
            this.props.history.push('/');
        }
    }

    handleShow() {
        this.setState({ show: true, effect: 'zoomIn' });
    }

    render() {
        // let { isLogged } = this.props;
        let { logged } = this.state;

        let base_ref_url = window.location.origin + '/affiliate/' + this.state.code;

        return (
            <>
                {!this.props.justModal && (
                    this.props.sidebar ? (
                        <span onClick={this.handleShow} className="cursor-pointer">
                            VIP Rewards
                        </span>
                    ) : (
                        <span onClick={this.handleShow} className={"dropdown-item"}>
                            <i className="dripicons-user-group text-muted mr-2 text-drop" />
                            VIP Rewards
                        </span>
                    )
                )}
                <Modal
                    size="md"
                    backdrop="static"
                    centered={true}
                    show={this.state.show}
                    onHide={this.handleClose}
                    aria-labelledby="help-md-modal"
                    className={"wallet-modal-custom animated " + this.state.effect}
                >
                    <Modal.Header className="Header border-0">
                        <div className="text-white font-weight-bold mx-2" style={{ fontSize: '1.25rem' }}>VIP Rewards</div>
                        <button type="button" className="close p-2" onClick={this.handleClose}>
                            <i className={'mdi mdi-close'} />
                        </button>
                    </Modal.Header>
                    <Modal.Body className="p-0">

                        <Helmet>
                            <title>VIP Rewards - Original Crash Game</title>
                        </Helmet>
                        <div className={'p-4'} style={{ background: 'rgba(16, 185, 129, 0.05)' }}>
                            <div className="balance-card-gradient p-4 mb-4 text-center">
                                <h4 className={'text-upper text-white font-weight-bold mb-0'}>Invite Friends & Earn</h4>
                                <p className="text-white-50 small mt-1">Get exclusive VIP bonuses for every new trader you refer</p>
                            </div>

                            <Row>
                                <Col sm={12} className={'m-auto'}>
                                    <div className="bg-dark-light p-4 rounded-lg border border-white-10 shadow-sm" style={{ background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '15px' }}>
                                        <label className="text-white-50 text-upper small font-weight-bold mb-3 d-block">Your VIP Invite Link</label>
                                        {logged ?
                                            <div className="input-group" style={{ border: "none" }}>
                                                <input type="text" value={base_ref_url} id={'code'} readOnly className={'form-control text-center text-white border-0'} style={{ background: "rgba(15, 23, 42, 0.6)", fontWeight: "600", borderRadius: '10px 0 0 10px' }} />
                                                <div className="input-group-append">
                                                    <span onClick={e => this.copyAddress('code')} className="input-group-text bgin cpt border-0" style={{ background: '#10b981', color: '#fff', borderRadius: '0 10px 10px 0' }}>
                                                        <i className="far fa-copy mr-2" /> Copy
                                                    </span>
                                                </div>
                                            </div>
                                            :
                                            <div className="text-center p-2 rounded" style={{ background: "rgba(15, 23, 42, 0.6)", color: 'rgba(255,255,255,0.5)' }}>
                                                Please login to see your code.
                                            </div>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="p-3">
                            <Row>
                                <Col sm={12} xl={12} md={12} className={'mx-auto'}>
                                    {!logged ?
                                        <div className="text-center text-white-50 p-4">[ Login to see your referral stats ]</div>
                                        :
                                        <div className="mt-2">
                                            <List />
                                        </div>
                                    }
                                </Col>
                            </Row>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

export default withRouter(Affiliate);